<template>
    <div
        class="md-content column"
        :style="{ backgroundColor: columnBackgroundColor }"
        v-if="picture || subTitle || description"
    >
        <img-box
            v-if="showImage"
            :src="picture"
            class="column-image"
            :showLoadingImg="false"
        ></img-box>
        <div class="column-info">
            <div
                class="sub-title"
                v-show="showSubTitle"
                v-if="subTitle"
                v-html="formatFontSize(subTitle, 18)"
                style="font-family:var(--font-normal);"
            ></div>
            <div
                class="description"
                v-if="description"
                v-html="formatFontSize(description, 14)"
                style="font-family:var(--font-normal);"
            ></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'column',
    props: {
        columnBackgroundColor: {
            type: String,
            default: ''
        },
        showImage: {
            type: Boolean,
            default: true
        },
        showSubTitle: {
            type: Boolean,
            default: true
        },
        subTitle: {
            type: String
        },
        description: {
            type: String
        },
        pictureOption: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        picture() {
            // TODO:  This judgment value should be proposed as global variables cannot be coupled in the logic
            if (!this.isMobileSize) {
                return (
                    this.pictureOption.src || this.pictureOption.mobileSrc || ''
                );
            } else {
                return (
                    this.pictureOption.mobileSrc || this.pictureOption.src || ''
                );
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-content.column {
    margin-bottom: 30px;
    .column-image {
        height: 240px;
        width: 100%;
        padding-bottom: 20px;
        .img-content {
            > img {
                @include object-fit(contain);
            }
        }
    }
    .column-info {
        .sub-title {
            padding: 20px 0 12px;
            margin: 0;
            font-size: 18px;
            line-height: 1.33;
            font-weight: 600;
            word-break: break-word;
            font-family: var(--font-normal);
            color: #414676;
        }
        .description {
            font-size: 14px;
            word-break: break-word;
            font-family: var(--font-normal);
            color: #7585b1;
        }
    }
}
</style>
